import React, { useEffect, useState } from "react";
import Request from "Services/index";
import fallback from "../../assets/img/order__page/other.png";

export default function RebarDrawing({ media }: { media?: { id?: number; file_field?: string } }) {
  const throughApi = window.location.hostname === "staging.easybar.co.il" && Boolean(media?.id);
  const [image, setImage] = useState({ url: "", loading: throughApi, failed: false });
  useEffect(() => {
    if (!throughApi) return;
    let active = true;
    let url: string | undefined;
    setImage({ url: "", loading: true, failed: false });
    Request.get(`media/${media!.id}/?download=1`, {}, { responseType: "blob" })
      .then(response => {
        if (!active) return;
        if (!response.data.type.startsWith("image/")) throw new Error("Invalid drawing image");
        url = URL.createObjectURL(response.data);
        setImage({ url, loading: false, failed: false });
      }).catch(() => { if (active) setImage({ url: "", loading: false, failed: true }); });
    return () => { active = false; if (url) URL.revokeObjectURL(url); };
  }, [throughApi, media?.id]);
  const source = throughApi ? image.url : media?.file_field?.replace(
    "https://easybar-s3.s3.amazonaws.com", "https://app.easybar.co.il") || fallback;
  return <img src={source || undefined} alt="rebar drawing"
    data-pdf-resource-loading={image.loading ? "true" : undefined}
    data-pdf-resource-error={image.failed ? "true" : undefined} />;
}
